import React from 'react';
import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import { BREAKPOINTS } from '@/constants';

import Arrow from '@/components/Arrow';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  SPRING_CONFIGS,
} from './bits';

function MarginCollapseOpposing() {
  const [hasEngaged, setHasEngaged] = React.useState(false);

  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -25}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 25}%)`,
    config: SPRING_CONFIGS[0],
  });

  React.useEffect(() => {
    if (stepIndex > 0) {
      setHasEngaged(true);
    }
  }, [stepIndex]);

  return (
    <OuterWrapper>
      <Wrapper {...handlers}>
        <Layer style={{ zIndex: 2, ...firstSpring }}>
          <Skew>
            <BaseElement>Paragraph One</BaseElement>
            <BaseMargin />
          </Skew>
          <Label
            orientation="up"
            isVisible={true}
            style={{
              bottom: '30%',
              left: '-25%',
            }}
          >
            margin-bottom: 24px
          </Label>
        </Layer>

        <Layer style={{ top: 175, ...secondSpring }}>
          <Skew>
            <BaseMargin />
            <BaseElement>Paragraph Two</BaseElement>
          </Skew>
          <Label
            orientation="down"
            isVisible={stepIndex === 2}
            style={{
              top: '30%',
              right: '-25%',
            }}
          >
            margin-top: 24px
          </Label>
        </Layer>
      </Wrapper>
      <Pointer style={{ opacity: hasEngaged ? 0 : 0.9 }}>
        <ArrowWrapper>
          <Arrow type="diagonal" variant={1} width={50} />
        </ArrowWrapper>
        <TextWrapper>
          <strong>This is an interactive element!</strong>
          <MobileText>Tap to view</MobileText>
          <DesktopText>Hover (or focus) to view</DesktopText>
        </TextWrapper>
      </Pointer>
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  position: relative;
`;

const Wrapper = styled(BaseWrapper)`
  height: 420px;
`;

const Pointer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120%;
  margin-left: -10%;
  padding-bottom: 96px;
  background: var(--color-background);
  backdrop-filter: blur(5px);
  opacity: 0.8;
  transition: opacity 750ms;
  pointer-events: none;
`;

const ArrowWrapper = styled.div`
  animation: sway 1000ms ease-in-out infinite alternate;
  margin-top: -32px;
  height: 85px;

  @keyframes sway {
    from {
      transform: rotate(-22deg);
    }
    to {
      transform: rotate(-15deg);
    }
  }
`;

const TextWrapper = styled.div`
  margin-top: 16px;
  text-align: center;

  strong {
    background: var(--color-background);
  }
`;

const MobileText = styled.div`
  background: var(--color-background);

  @media ${BREAKPOINTS.smAndLarger} {
    display: none;
  }
`;
const DesktopText = styled.div`
  background: var(--color-background);

  @media ${BREAKPOINTS.smAndSmaller} {
    display: none;
  }
`;

export default MarginCollapseOpposing;
